(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('BannerImage', BannerImage);

    BannerImage.$inject = ['$resource'];

    function BannerImage ($resource) {
        var resourceUrl =  'api/banner-images/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
